// ═══════════════════════════════════════════════════════════════════
// CARTE DES DOMAINES — Multi-tenant AbracadaWorld
// ═══════════════════════════════════════════════════════════════════
// Un seul site, plusieurs portes d'entrée : chaque nom de domaine possédé
// ouvre le même code avec un habillage/comportement différent.
//
// TEST EN PREVIEW (sans toucher aux vrais domaines) :
//   …vercel.app/?domaine=abracadabati.com   → porte Bâtiment
//   …vercel.app/?domaine=abracadaworld.com  → porte Centre commercial
//   …vercel.app/?domaine=abracada.app       → porte Abra
//   …vercel.app/?domaine=abracada.pro       → vitrine pros (page de vente /pro)
//   …vercel.app/?domaine=app.abracada.pro   → cockpit pro direct (PWA Abracada Pro)
//   …vercel.app/?domaine=reset              → retour au comportement par défaut
// Le choix est mémorisé pour la session (navigation comprise).

export const TENANTS = {
  bati: {
    id: 'bati',
    label: 'AbracadaBati',
    // Porte d'entrée www.abracadabati.com : accueil Bâtiment en grand,
    // rail Abra fin à gauche (desktop), accueil mobile actuel.
    abraRail: true,
  },
  world: {
    id: 'world',
    label: 'AbracadaWorld',
    // abracadaworld.com : le centre commercial complet (comportement à venir)
    abraRail: false,
  },
  app: {
    id: 'app',
    label: 'Abracada',
    // abracada.app : l'assistant Abra qui pilote tout (comportement à venir)
    abraRail: false,
  },
  pro: {
    id: 'pro',
    label: 'Abracada Pro',
    // app.abracada.pro (+ pro.abracadabati.com) : le cockpit pro direct —
    // centre de pilotage des pros, installable en application (PWA « Abracada Pro »)
    abraRail: false,
    proDirect: true, // arrivée sur '/' → redirection /cockpit-pro
    manifest: '/manifest-pro.json',
    titre: 'Abracada Pro — Cockpit professionnel',
  },
  provitrine: {
    id: 'provitrine',
    label: 'Abracada Pro — vitrine',
    // abracada.pro : la vitrine qui vend le concept aux professionnels
    abraRail: false,
    vitrinePro: true, // arrivée sur '/' → la page de vente /pro
    titre: 'Abracada Pro — Loue ta boutique, zéro commission',
  },
};

const DOMAIN_TO_TENANT = {
  'abracadabati.com': 'bati',
  'www.abracadabati.com': 'bati',
  'pro.abracadabati.com': 'pro',
  'app.abracada.pro': 'pro',
  'abracada.pro': 'provitrine',
  'www.abracada.pro': 'provitrine',
  'abracadapro.com': 'provitrine',
  'www.abracadapro.com': 'provitrine',
  'abracadaworld.com': 'world',
  'www.abracadaworld.com': 'world',
  'abracada.app': 'app',
  'www.abracada.app': 'app',
};

const STORAGE_KEY = 'abracada_domaine_simule';

export function resolveTenant() {
  if (typeof window === 'undefined') return TENANTS.bati;
  try {
    const simule = new URLSearchParams(window.location.search).get('domaine');
    if (simule === 'reset') {
      sessionStorage.removeItem(STORAGE_KEY);
    } else if (simule) {
      sessionStorage.setItem(STORAGE_KEY, simule.toLowerCase().trim());
    }
    const host = (
      sessionStorage.getItem(STORAGE_KEY) || window.location.hostname
    ).toLowerCase();
    const tenantId = DOMAIN_TO_TENANT[host];
    if (tenantId) return TENANTS[tenantId];
  } catch (e) {
    // sessionStorage indisponible (navigation privée stricte…) : défaut
  }
  // Par défaut (previews vercel.app, localhost) : porte AbracadaBati
  return TENANTS.bati;
}
